import { Component } from '@angular/core';
import { DialogComponent, DialogService } from "ng2-bootstrap-modal";

export interface SurveyErrorModel {
	title:string;
	message:string;
}

@Component({  
    selector: 'survey-error-activate',
    template: `<div class="modal-dialog">
	                <div class="modal-content">
	                   	<div class="modal-header">
	                     	<h4 class="modal-title">{{title}}</h4>
	                     	<button type="button" class="close" (click)="close()" >&times;</button>
	                   	</div>
	                   	<div class="modal-body">
	                     	<p>{{message}}</p>
	                   	</div>
	                   	<div class="modal-footer">
	                     	<button type="button" class="btn btn-danger" (click)="close()">Natrag</button>
	                   	</div>
	                </div>
              	</div>`,
    styles: [
    	`
    	.modal-footer,
    	.modal-body { 
    		border-top: 1px solid #eceeef; 
    	}
    	.modal-header {
    		padding: 10px 15px;
    	}
    	`]
})

export class SurveyErrorActivateComponent extends DialogComponent<SurveyErrorModel, boolean> implements SurveyErrorModel {
  	title: string;
  	message: string;
  	constructor(dialogService: DialogService) {
    	super(dialogService);
  	}
  	confirm() {
    	// we set dialog result as true on click on confirm button, 
    	// then we can get dialog result from caller code 
    	this.close();
  	}
}


// WEBPACK FOOTER //
// /opt/stranka/FrontOffice/src/app/modals/confirm/survey-activate-error-message.component.ts